<template>
  <table class="b2b-table b2b-table--vstripe b2b-product-compare-table" qaid="productCompareLoveWrapper">
    <tbody>
      <tr
        v-for="(section, sectionIndex) in sectionData.compareItems"
        :key="sectionIndex"
        :qaid="`productCompareLoveRow-${sectionIndex}`"
      >
        <th scope="row" :qaid="`productCompareLoveLabel-${sectionIndex}`">{{ section.label }}</th>
        <td
          v-for="(product, productIndex) in section.products"
          :key="productIndex"
          :data-spec="section.label"
          :qaid="`productCompareLoveCell-${productIndex}`"
        >
          <template v-if="product && section.code === 'localizedVideoOverview'">
            <a
              :title="product.caption"
              :href="product.url"
              data-video
              class="sprocket__play-overlay"
              :qaid="`productCompareLoveVideoLink-${productIndex}`"
            >
              <img :src="product.scene7StillAssetId" />
            </a>
          </template>
          <template v-else>
            <div :qaid="`productCompareLoveText-${productIndex}`">{{ product }}</div>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    sectionData: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
